import React from "react";
import "./Loader.css";

const Loader = ({
  message = "Loading...",
  size = "medium",
  type = "dots",
  overlay = true,
  blur = true, // Add this new prop
}) => {
  const sizes = {
    small: { dotSize: "8px", fontSize: "12px" },
    medium: { dotSize: "12px", fontSize: "14px" },
    large: { dotSize: "16px", fontSize: "16px" },
  };

  const { dotSize, fontSize } = sizes[size] || sizes.medium;

  const loaderContent =
    type === "spinner" ? (
      <div className="spinner-wrapper">
        <div
          className="spinner"
          style={{ width: dotSize, height: dotSize }}
        ></div>
        <div className="loader-text" style={{ fontSize }}>
          {message}
        </div>
      </div>
    ) : (
      <div className="loader-content">
        <div className="dot-wrapper">
          <div className="dot" style={{ width: dotSize, height: dotSize }}></div>
          <div className="dot" style={{ width: dotSize, height: dotSize }}></div>
          <div className="dot" style={{ width: dotSize, height: dotSize }}></div>
        </div>
        <div className="loader-text" style={{ fontSize }}>
          {message}
        </div>
      </div>
    );

  if (overlay) {
    return (
      <div 
        className="loader-overlay" 
        style={!blur ? { backdropFilter: "none" } : {}}
      >
        {loaderContent}
      </div>
    );
  }

  // Non-overlay version
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "rgba(255, 255, 255, 0.95)",
        padding: "20px 30px",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
        zIndex: 10000,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid rgba(0, 90, 134, 0.1)",
      }}
    >
      {loaderContent}
    </div>
  );
};

export default Loader;